import { DiscountType, Voucher, VoucherCollection, VoucherTag } from '@/app/shared/interface/voucher.interface';
import { VoucherService } from '@/app/shared/services/voucher.service';
import { VoucherDetailModalComponent } from '@/app/shared/widgets/modal/voucher-modal/voucher-detail-modal/voucher-detail-modal.component';
import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, firstValueFrom, Subject } from 'rxjs';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrl: './voucher.component.scss'
})
export class VoucherComponent {

  @ViewChild("voucherSearchInput", { static: false }) voucherSearchInput: any;

  @Input() applicableVouchers: Voucher[] = [];
  @Input() isCheckout: boolean = false;

  @Output() applyVoucher = new EventEmitter<Voucher>();
  @Output() getApplicableVouchers = new EventEmitter<any>();

  voucherGroups: {
    collection: {
      name: string;
      slug: string;
      index: number;
    },
    vouchers: Voucher[],
    isExpanded: boolean;
  }[] = [];
  vouchers: Voucher[] = [];
  voucherHistories: Voucher[] = [];

  voucherTags: VoucherTag[] = [{
    name: "Tất cả",
    slug: "",
    active: true
  }];

  public skeletonLoader: boolean = true;
  public skeletonItems = Array.from({ length: 4 }, (_, index) => index);

  fromDate: string;
  toDate: string;

  public modalOpen: boolean = false;

  headerColumns = [
    "Ngày Sử Dụng",
    "Mã giảm giá",
    "Thông tin",
    "Đơn hàng liên quan"
  ];

  private searchSubject = new Subject<string>();

  body: {
    keyword?: string;
    tags?: string;
  }

  form: FormGroup;

  constructor(
    private voucherService: VoucherService,
    private toastService: ToastrService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.form = this.formBuilder.group({
      searchInput: ['']
    });
  }

  ngOnChanges() {
    this.vouchers = this.applicableVouchers;
    if (this.vouchers.length > 0) {
      this.groupVouchersByCollection(this.vouchers);
    }
  }

  ngOnInit() {
    if (!this.isCheckout) {
      this.getVouchers();
      this.getTags();
    }
    else {
      if (this.vouchers.length > 0) {
        this.groupVouchersByCollection(this.vouchers);
      }
      this.getTags();
    }

    this.searchSubject.pipe(debounceTime(300)).subscribe((searchValue) => {
      this.body = {
        ...this.body,
        keyword: searchValue
      };
      if (!this.isCheckout) {
        this.getVouchers(this.body);
      }
      else {
        this.getApplicableVouchers.emit(this.body);
      }
    });
    //this.getVoucherHistories();
  }

  getTags() {
    this.voucherService.getTags().subscribe({
      next: (res: VoucherTag[]) => {
        this.voucherTags = [...this.voucherTags, ...res.map(tag => ({ ...tag, active: false }))];
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }

  groupByProperty(array: any, property: any) {
    return array.reduce((grouped: any, element: any) => ({
      ...grouped,
      [element[property]]: [...(grouped[element[property]] || []), element]
    }), {});
  }

  getVouchers(param?: any) {
    this.voucherService.getAvailableVouchers(param).subscribe({
      next: (res: Voucher[]) => {
        this.vouchers = res;
        this.groupVouchersByCollection(this.vouchers);

        // const vouchersWithoutCollection = this.vouchers.filter(voucher => !voucher.collection || voucher.collection.length === 0);
        // if (vouchersWithoutCollection.length > 0) {
        //   this.voucherGroups.push({
        //     collection: {
        //       name: 'Khác',
        //       slug: '',
        //       index: Number.MAX_SAFE_INTEGER
        //     },
        //     vouchers: vouchersWithoutCollection
        //   });
        // }
      },
      error: (error: any) => {
        console.log(error);
      },
      complete: () => {
        this.skeletonLoader = false;
      }
    });
  }

  groupVouchersByCollection(vouchers: Voucher[]): any {
    this.skeletonLoader = false;

    this.voucherGroups = [];
    let collectionSlugs: any;

    if (this.isCheckout) {
      collectionSlugs = [...new Set(vouchers.map((item: Voucher) => item.collection?.slug))];
    }
    else {
      collectionSlugs = [...new Set(vouchers.map((item: Voucher) => item.voucherCollection?.slug))];
    }

    for (let slug of collectionSlugs) {
      let vouchersWithCollection: Voucher[] = [];

      if (this.isCheckout) {
        vouchersWithCollection = vouchers.filter(voucher => voucher.collection?.slug === slug);
        if (vouchersWithCollection.length > 0) {
          this.voucherGroups.push({
            collection: {
              name: vouchersWithCollection[0].collection?.name || '',
              slug: slug,
              index: vouchersWithCollection[0].collection?.index || 0
            },
            vouchers: vouchersWithCollection,
            isExpanded: false
          });
        }
      }
      else {
        vouchersWithCollection = vouchers.filter(voucher => voucher.voucherCollection?.slug === slug);
        if (vouchersWithCollection.length > 0) {
          this.voucherGroups.push({
            collection: {
              name: vouchersWithCollection[0].voucherCollection?.name || '',
              slug: slug,
              index: vouchersWithCollection[0].voucherCollection?.index || 0
            },
            vouchers: vouchersWithCollection,
            isExpanded: false
          });
        }
      }
    }

    this.voucherGroups.sort((a, b) => a.collection.index - b.collection.index);
  }

  copyToClipboard(voucher: Voucher) {
    if(isPlatformBrowser(this.platformId)) {
      navigator.clipboard.writeText(voucher.code);
    }
    this.toastService.success("Sao chép mã giảm giá thành công!", "" , {positionClass: "toast-top-right"});
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  inputKeyword() {
    const inputValue = this.form.get('searchInput')?.value || '';
    this.body = {
      ...this.body,
      keyword: inputValue
    };
    this.searchSubject.next(inputValue);
  }

  selectTag(tag: VoucherTag) {
    if (tag.slug === "") {
      if (tag.active) {
        return;
      }
      this.voucherTags.forEach(t => t.active = false);
    }
    else {
      this.voucherTags[0].active = false;
    }
    tag.active = !tag.active;
    let tags = this.voucherTags.filter(t => t.active).map(t => t.slug);
    if (tags.length === 0) {
      tags = [""];
      this.voucherTags[0].active = true;
    }
    this.body = {
      ...this.body,
      tags: tags.join(',')
    };

    if (!this.isCheckout) {
      this.getVouchers(this.body);
    }
    else {
      this.getApplicableVouchers.emit(this.body);
    }
  }

  ngOnDestroy() {
    this.modalService.dismissAll();
  }
}
